import PropTypes from "prop-types"
import { Navigate, useParams } from "react-router-dom"
import { isEmpty, reduce, replace } from "lodash"
import { getQueryStringState, stringifyState } from "helpers/queryString"

export default function RedirectWithParams({ to }) {
  const params = useParams()
  const queryString = getQueryStringState()

  let path = reduce(params, (previousPath, paramValue, paramName) => {
    if (paramValue) {
      return replace(previousPath, `:${paramName}`, paramValue)
    }
    return previousPath
  }, to)
  if (!isEmpty(queryString)) {
    path += `?${stringifyState(queryString)}`
  }
  return <Navigate to={path} replace />
}

RedirectWithParams.propTypes = {
  to: PropTypes.string.isRequired,
}
